export const formatDashboardCurrency = (value) => {
  if (value === null || value === undefined || value === "") {
    return "£0.00";
  }
  const numValue = parseFloat(value);
  if (Number.isNaN(numValue)) {
    return "£0.00";
  }
  return `£${numValue.toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const clientTileStats = (clients) => {
  if (!clients) {
    return null;
  }
  return [
    { label: "Total Clients", value: clients.total || 0 },
    { label: "Active", value: clients.active || 0 },
    { label: "Inactive", value: clients.inactive || 0 },
    { label: "External", value: clients.external || 0 },
    { label: "Internal", value: clients.internal || 0 },
    { label: "With AI Systems", value: clients.withAiSystems || 0 },
  ];
};

export const aiSystemsTileStats = (aiSystems) => {
  if (!aiSystems) {
    return null;
  }
  return [
    { label: "Total Systems", value: aiSystems.total || 0 },
    { label: "Approved", value: aiSystems.approved || 0 },
    { label: "Under Assessment", value: aiSystems.underAssessment || 0 },
    { label: "Deployed", value: aiSystems.deployed || 0 },
    { label: "Reviews Due Soon", value: aiSystems.reviewsDueSoon || 0 },
    { label: "Reviews Overdue", value: aiSystems.reviewsOverdue || 0 },
  ];
};

export const TILE_STAT_SLOTS = 8;

export const padTileStats = (stats, slotCount = TILE_STAT_SLOTS) => {
  const items = Array.isArray(stats) ? stats.slice(0, slotCount) : [];
  const padded = [...items];
  while (padded.length < slotCount) {
    padded.push({ label: "", value: "", placeholder: true });
  }
  return padded;
};
